import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import { deserialize } from "utils/storeUtils";
import PageRepository from "repositories/PageRepository";
import { jjLogger } from "utils/logUtils";
import { PAGE_MODULES } from "enums/pageModules";

const initialState = {
  homePage: null,
  carousel: null,
  featuredEcards: null,
  viewMoreButton: null,
};

const homePageSlice = createSlice({
  name: "homePage",
  initialState,
  reducers: {
    loadHomePageSuccess(state, { payload }) {
      const response = deserialize(payload);

      const modules = response?.pageModules?.map((module) => {
        const deserializedModule = deserialize({ data: module });

        if (module.type === PAGE_MODULES.ALGOLIA_CARDS) {
          return {
            ...deserializedModule,
            internalType: deserializedModule.type,
            type: PAGE_MODULES.ALGOLIA_CARDS,
          };
        }

        return deserializedModule;
      });

      response.pageModules = modules;
      const [carousel, featuredEcards, viewMoreButton] = response.pageModules;

      state.homePage = response;
      state.carousel = carousel;
      state.featuredEcards = featuredEcards;
      state.viewMoreButton = viewMoreButton;
    },
  },
});

export const { actions } = homePageSlice;
export default homePageSlice.reducer;

export const useHomePageActions = () => {
  const dispatch = useDispatch();

  const loadHomePage = () => {
    return PageRepository.show("home-page")
      .then(({ data }) => {
        dispatch(homePageSlice.actions.loadHomePageSuccess(data));
        return data;
      })
      .catch((error) => jjLogger.logError(error));
  };

  return {
    loadHomePage,
  };
};
